module.exports = __webpack_public_path__ + "img/Horario.2558e864.svg";